import Medal from '../src/Medal/index';
export default Medal;
